export const EXTENSIONS_LOCATION = process.env.VSCODE
  ? '/vscode/extensions-bundle'
  : '/public/vscode-extensions/v17';

export const VIM_EXTENSION_ID = 'vscodevim.vim';

export const WAIT_INITIAL_TYPINGS_MS = 1000;
